.gameTooltip {
  position: fixed;
  z-index: 150;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: min(300px, calc(100vw - 24px));
  padding: 9px 12px;
  color: #d6eafb;
  background: #071925;
  border: 1px solid #296080;
  border-left: 2px solid #25b7ff;
  border-radius: 3px;
  box-shadow: 0 6px 24px rgba(0, 4, 10, 0.7);
  font:
    11px/1.5 var(--font-geist-mono),
    monospace;
  letter-spacing: 0.01em;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

.gameTooltip__signal {
  flex: 0 0 4px;
  width: 4px;
  height: 4px;
  background: #25b7ff;
  box-shadow: 0 0 8px rgba(37, 183, 255, 0.35);
}

.gameTooltip--highContrast {
  color: #fff;
  background: #020b13;
  border-color: #71c9ff;
}

@media (prefers-contrast: more) {
  .gameTooltip {
    color: #fff;
    background: #020b13;
    border-color: #71c9ff;
  }
}
